const BRAND_COLOR = '#66A573'
const BRAND_COLOR_DARK = '#4d8a5a'
const APP_NAME = 'Ask QUIEN'
const APP_NAME_HTML = `<span style="font-family:'SFMono-Regular',Consolas,'Liberation Mono',monospace;font-weight:700;color:${BRAND_COLOR};">Ask QUIEN</span>`
const LOGO_URL = 'https://quality-intelligence.co/brand/qi-mark.png'
const APP_URL = process.env.AUTH_URL ?? process.env.NEXTAUTH_URL ?? 'https://quality-intelligence.co'

export function buildTicketQueuedEmail({
  ticketReference,
  ticketTitle,
  ticketId,
}: {
  ticketReference: string
  ticketTitle: string
  ticketId: string
}): { subject: string; html: string; text: string } {
  const ticketUrl = `${APP_URL}/tickets/${ticketId}`
  const subject = `[${ticketReference}] Your issue is in the expert queue`

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${subject}</title>
</head>
<body style="margin:0;padding:0;background-color:#f4f4f5;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f5;padding:40px 16px;">
    <tr>
      <td align="center">
        <table width="100%" cellpadding="0" cellspacing="0" style="max-width:480px;">

          <!-- Brand header -->
          <tr>
            <td align="center" style="padding-bottom:24px;">
              <img src="${LOGO_URL}" width="64" height="64" alt="${APP_NAME}" style="display:block;border-radius:12px;" />
              <p style="margin:12px 0 0;font-size:18px;">${APP_NAME_HTML}</p>
            </td>
          </tr>

          <!-- Card -->
          <tr>
            <td style="background-color:#ffffff;border-radius:12px;border:1px solid #e4e4e7;padding:40px 40px 32px;">
              <table width="100%" cellpadding="0" cellspacing="0">

                <!-- Ticket ref -->
                <tr>
                  <td style="padding-bottom:4px;">
                    <p style="margin:0;font-size:11px;font-family:monospace;color:#71717a;">${ticketReference}</p>
                  </td>
                </tr>

                <!-- Heading -->
                <tr>
                  <td style="padding-bottom:20px;">
                    <p style="margin:0;font-size:20px;font-weight:700;color:#18181b;letter-spacing:-0.3px;">Your issue is in the expert queue</p>
                  </td>
                </tr>

                <!-- Ticket title -->
                <tr>
                  <td style="padding-bottom:16px;">
                    <p style="margin:0;font-size:13px;font-weight:600;color:#52525b;text-transform:uppercase;letter-spacing:0.4px;">Ticket</p>
                    <p style="margin:4px 0 0;font-size:15px;color:#18181b;">${ticketTitle}</p>
                  </td>
                </tr>

                <!-- Divider -->
                <tr><td style="border-top:1px solid #f4f4f5;padding-bottom:16px;"></td></tr>

                <!-- Body -->
                <tr>
                  <td style="padding-bottom:28px;">
                    <p style="margin:0;font-size:15px;line-height:1.7;color:#18181b;">
                      Your issue has been reviewed and is now in the queue. An expert will get back to you as soon as possible. You'll receive another email when they respond.
                    </p>
                  </td>
                </tr>

                <!-- CTA -->
                <tr>
                  <td align="center" style="padding-bottom:28px;">
                    <a href="${ticketUrl}"
                       style="display:inline-block;background-color:${BRAND_COLOR};color:#ffffff;text-decoration:none;font-size:15px;font-weight:600;padding:14px 32px;border-radius:8px;"
                       onmouseover="this.style.backgroundColor='${BRAND_COLOR_DARK}'"
                       onmouseout="this.style.backgroundColor='${BRAND_COLOR}'">
                      View ticket
                    </a>
                  </td>
                </tr>

                <!-- Fallback link -->
                <tr>
                  <td style="padding-bottom:24px;border-top:1px solid #f4f4f5;padding-top:20px;">
                    <p style="margin:0;font-size:12px;color:#71717a;">Or paste this link into your browser:</p>
                    <p style="margin:6px 0 0;font-size:11px;word-break:break-all;">
                      <a href="${ticketUrl}" style="color:${BRAND_COLOR};text-decoration:none;">${ticketUrl}</a>
                    </p>
                  </td>
                </tr>

              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td align="center" style="padding-top:24px;">
              <p style="margin:0;font-size:12px;color:#a1a1aa;">&copy; ${new Date().getFullYear()} Quality Intelligence &middot; <a href="${APP_URL}" style="color:#a1a1aa;text-decoration:none;">quality-intelligence.co</a></p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`

  const text = `Your issue is in the expert queue\n\n${ticketReference} — ${ticketTitle}\n\nYour issue has been reviewed and is now in the queue. An expert will get back to you as soon as possible. You'll receive another email when they respond.\n\nView your ticket here:\n${ticketUrl}\n\n— ${APP_NAME} / quality-intelligence.co`

  return { subject, html, text }
}
